import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

import Typography from '@/components/Rain/Typography/Typography.vue'
import { FontAwesomeIcon } from 'fontawesome/vue-fontawesome'
import { faCircleRight } from 'fontawesome/free-solid-svg-icons'
import { computed } from 'vue'
import store from '@/mobile/src/store'
import router from '@/mobile/src/router'


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewAsNavBar',
  setup(__props) {

const userName = computed(() => store.getters['userName'])
const isImpersonating = computed(() => store.getters['isImpersonating'])

return (_ctx: any,_cache: any) => {
  return (isImpersonating.value)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "impersonating",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(router).push({ name: 'viewAs' })))
      }, [
        _createVNode(Typography, {
          variant: "overline",
          class: "impersonating-text"
        }, {
          default: _withCtx(() => [
            _createTextVNode("Viewing as " + _toDisplayString(userName.value), 1)
          ], undefined, true),
          _: 1
        }),
        _createVNode(_unref(FontAwesomeIcon), {
          class: "impersonating-change-icon",
          icon: _unref(faCircleRight)
        }, null, 8, ["icon"])
      ]))
    : _createCommentVNode("", true)
}
}

})